import { createApi } from "@reduxjs/toolkit/query/react";
import { customBaseQuery } from "./common";
import { Mk8sCluster } from "../../schema/types/mk8s/entity/mk8s";
import { KubernetesNode } from "../../schema/types/mk8s/node";

export const mk8sApi = createApi({
  reducerPath: "mk8sApi",
  baseQuery: customBaseQuery,
  tagTypes: ["Mk8sCluster", "Mk8sNodes"],
  endpoints: (builder) => ({
    getMk8sCluster: builder.query<Mk8sCluster, string>({
      queryFn: async (link) => {
        try {
          const { request } = await import("../../services/cpln");
          const { data } = await request({ url: link });
          return { data };
        } catch (error: any) {
          return {
            error: {
              status: error.response?.status || 500,
              data: error.response?.data || error.message,
            },
          };
        }
      },
      providesTags: (result, error, link) => [{ type: "Mk8sCluster", id: link }],
    }),
    getMk8sNodes: builder.query<KubernetesNode[], string>({
      queryFn: async (link) => {
        try {
          const { request } = await import("../../services/cpln");
          const { data } = await request({ url: `${link}/-status/nodes` });
          const nodes: KubernetesNode[] = Array.isArray(data) ? data : data.items ? data.items : [data];
          return { data: nodes };
        } catch (error: any) {
          return {
            error: {
              status: error.response?.status || 500,
              data: error.response?.data || error.message,
            },
          };
        }
      },
      providesTags: (result, error, link) => [{ type: "Mk8sNodes", id: link }],
    }),
  }),
});

export const { useGetMk8sClusterQuery, useGetMk8sNodesQuery } = mk8sApi;
